import { writable } from 'svelte/store';
import localeCodes from 'locale-codes';
import { cleanLanguages } from '../components/Contents/Languages/languages.utils';
let allLanguages = localeCodes.all;
allLanguages = cleanLanguages(allLanguages);
export const allLanguagesList = writable(allLanguages);
